import React from 'react';

interface IRxMaintenancePlaceholderProps {
    header?: string;
    message?: string;
}

export const RxMaintenancePlaceholder = (props: IRxMaintenancePlaceholderProps) => {
    return (
        <div className="RxMaintenancePlaceholder">
            <img className="RxMaintenancePlaceholder__Image" src="/dist/assets/images/maintenance.svg" />
            <div className="RxMaintenancePlaceholder__Text">
                {props.header && <div className="RxMaintenancePlaceholder__Header">{props.header}</div>}
                {props.message && <div className="RxMaintenancePlaceholder__Message">{props.message}</div>}
            </div>
        </div>
    );
};
